<template>
  <div
    class="chart-container-outer"
    data-aos="zoom-out"
    data-aos-offset="400"
    :data-aos-id="aosId"
  >
    <div class="chart-container">
      <slot/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChartContainer',
  props: ['aosId'],
};
</script>
